<template>
  <div class="myGiftcontent">
    <titlebar titleName="我的礼包" goback="true"></titlebar>
    <div class="content">
      <van-tabs
        v-model="active"
        color="#FF961C"
        title-active-color="#FF961C"
        title-inactive-color="#FF961C"
        class="tabbar"
        @change="change"
      >
        <van-tab title="未过期">
          <ul class="list1">
            <li class="item" v-for="(item1, index1) in data" :key="index1">
              <div class="top">
                <div class="info">
                  <img :src="item1.game_info.game_icon" alt="" class="img" />
                  <div class="info2">
                    <p>{{ item1.game_info.game_name }}</p>
                    <p>{{ item1.game_info.play }}小时</p>
                  </div>
                </div>
                <div class="btn">启动</div>
              </div>
              <van-divider />
              <ul class="giftlist">
                <li
                  class="giftItem"
                  v-for="(item, index) in item1.list"
                  :key="index"
                >
                  <div class="info2">
                    <p>{{ item.title }}</p>
                    <p>{{ item.summary }}</p>
                    <p>剩余：{{ item.surplus }}</p>
                  </div>
                  <div class="btn2">领取</div>
                </li>
              </ul>
              <div
                class="sq"
                v-if="item1.list.length > 1 && item1.isShow == false"
              >
                <van-icon name="arrow-down" @click="show(index1)" />展开
              </div>
              <div class="sq" v-if="item1.isShow">
                <van-icon name="arrow-up" @click="show(index1)" />收起
              </div>
            </li>
          </ul>
        </van-tab>
        <van-tab title="已过期">
          <ul class="list1">
           <li class="item" v-for="(item1, index1) in data" :key="index1">
              <div class="top">
                <div class="info">
                  <img :src="item1.game_info.game_icon" alt="" class="img" />
                  <div class="info2">
                    <p>{{ item1.game_info.game_name }}</p>
                    <p>{{ item1.game_info.play }}小时</p>
                  </div>
                </div>
                <div class="btn">启动</div>
              </div>
              <van-divider />
              <ul class="giftlist">
                <li
                  class="giftItem"
                  v-for="(item, index) in item1.list"
                  :key="index"
                >
                  <div class="info2">
                    <p>{{ item.title }}</p>
                    <p>{{ item.summary }}</p>
                    <p>剩余：{{ item.surplus }}</p>
                  </div>
                  <div class="btn2">领取</div>
                </li>
              </ul>
              <div
                class="sq"
                v-if="item1.list.length > 1 && item1.isShow == false"
              >
                <van-icon name="arrow-down" @click="show(index1)" />展开
              </div>
              <div class="sq" v-if="item1.isShow">
                <van-icon name="arrow-up" @click="show(index1)" />收起
              </div>
            </li>
          </ul>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import apiFun from "../../servers/apiFun";
import comTool from "../../assets/js/until";
import titlebar from "../../components/index/titleBar.vue";
export default {
  components: {
    titlebar,
  },
  data() {
    return {
      active: "1",
      data: [],
      data1: [],
    };
  },
  created() {
    this.getList("1");
  },
  methods: {
    show(index) {
      console.log(index);
      this.data[index].isShow = !this.data[index].isShow;
    },
    change() {
        console.log(this.active);
      if (this.active == "0") {
        this.getList("1");
      } else {
        this.getList("2");
      }
    },
    getList(index) {
      let data = {
        gid: "100682",
        pid: "100",
        mid: "10000",
        p_mid: "1",
        device_id: "00e7efa241dae8842c8286cf69508e9c",
        client: "h5",
        type: index,
        client_id: "00e7efa241dae8842c8286cf69508e9c",
        tm: comTool.getTm(),
        access_token: this.$cookies.get("access_token"),
        uname: this.$cookies.get("uname"),
      };
      data.sign = comTool.querySort(data);
      apiFun.MyGift(data).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].isShow = false;
        }
        this.data = res.data;
      });
    },
  },
};
</script>

<style lang="less"  scoped>
.content {
  padding-top: 13vw;
  /deep/ .van-tabs__wrap {
    width: 92vw;
    height: 10.4vw;
    margin: 3vw auto;
    border-radius: 3vw;
  }
  .list1 {
    .item {
      width: 92vw;
      background: #fff;
      margin: 0 auto;
      border-radius: 3vw;
      padding: 0 3.0667vw;
      margin-bottom: 10vw;
      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 4.1333vw;
        .info {
          display: flex;
          align-items: center;
          .img {
            width: 10.8vw;
            height: 10.8vw;
            border-radius: 3vw;
            margin-right: 1.6vw;
          }
          .info2 {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            :first-child {
              font-size: 4vw;
              color: #000;
              font-weight: 600;
            }
            :last-child {
              font-size: 3vw;
            }
          }
        }
        .btn {
          width: 13.3333vw;
          height: 6.2667vw;
          line-height: 6.2667vw;
          color: #ff961c;
          border: 0.3vw solid #ff961c;
          border-radius: 1.5vw;
          font-size: 3.5vw;
        }
      }
      .giftlist {
        padding-bottom: 2vw;
        .giftItem {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 3vw;
          .info2 {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
            :first-child {
              font-size: 4vw;
              font-weight: 600;
              color: #000;
            }
            :nth-child(2) {
              width: 70vw;
              font-size: 3.5vw;
              color: #a3a3a3;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }
            :last-child {
              font-size: 3.5vw;
              color: #ff961c;
            }
          }
          .btn2 {
            width: 13.3333vw;
            height: 6.2667vw;
            line-height: 6.2667vw;
            color: #ff961c;
            border: 0.3vw solid #ff961c;
            border-radius: 1.5vw;
            font-size: 3.5vw;
          }
        }
      }
      .sq {
        text-align: center;
        color: #ff961c;
        padding-bottom: 2vw;
      }
    }
  }
}
</style>